<ng-template #progressBarTooltip>{{ tooltip }}</ng-template>
<div class="progress" [style.height.px]="height" [ngbTooltip]="progressBarTooltip">
  <div
    class="progress-bar"
    [style.width.%]="value"
    role="progressbar"
  ></div>
</div>
